import { useEventListener } from '@vueuse/core';
/**
 * Focuses the bound element on Cmd+K / Ctrl+K. The element is passed as a
 * template ref so the composable does not need to know about its DOM identity.
 *
 * Cleanup is automatic — useEventListener removes the listener on unmount.
 */
export function useCmdK(targetRef) {
    useEventListener(window, 'keydown', (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
            event.preventDefault();
            targetRef.value?.focus();
        }
    });
}
